<template>
  <div class="contact-page">
    <div class="top-banner">
      <div class="banner-info">
        <div class="label">用心服务，全程守护</div>
      </div>
    </div>

    <div class="contact-main ">
      <div class="sub-title">售前咨询</div>

      <div class="info-box">
        <div class="box">
          <div class="label">购买咨询</div>
          <div class="phone">
            <img :src="baseUrl + '/icon-phone.png'" alt="">
            <span class="number">13911834340</span>
            <span>（微信同号）</span>
          </div>
        </div>
        <div class="box">
          <div class="label">企业版试用</div>
          <div class="info">留下你的联系方式和咨询的问题，我们将在24小时内联系您</div>
          <div class="btn">
            <img :src="baseUrl + '/icon-edit.png'" alt="">
            填写表单
          </div>
        </div>
      </div>


      <div class="sub-title">商务合作</div>

      <div class="kefu-box">
        <div class="bg">
          <div class="label">诚启未来，信筑共赢</div>
          <div class="space"></div>
          <div class="label2">商务合作电话</div>
          <div class="phone">
            13911834340
            <span class="small">（微信同号）</span>
          </div>
        </div>
        <img :src="baseUrl + '/contract.png'" class="kefu-bg" alt="">
      </div>

      <div class="kefu-box2">
        <img :src="baseUrl + '/kefu.png'" class="kefu-bg2" alt="">

        <div class="info">
          <div class="sub-title2">售后服务与投诉</div>
          <div class="item-box">
            <div class="item">
              <div class="label">售后服务</div>
              <div class="value">13911834340<span class="gray">（微信同号）</span></div>
            </div>
            <div class="item">
              <div class="label">投诉电话</div>
              <div class="value">18845893490</div>
            </div>
          </div>
        </div>
      </div>


      <div class="sub-title">微信小程序</div>


      <div class="wechat-box">
        <div class="circle-bg1"></div>
        <div class="circle-bg2"></div>
        <div class="circle-bg3"></div>
        <div class="circle-bg4"></div>
        <div class="phone-box">
          <div class="label">“医信圈”小程序</div>
          <img :src="baseUrl + '/qrcode.jpg'" alt="">
          <div class="btn">扫码免费查看最新行业资讯</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { baseUrl } from '@/utils';
</script>

<style lang="less" scoped>
.contact-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  .top-banner {
    height: 600px;
    width: 70%;
    background: url('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/banner4.png') left center / cover no-repeat;
  }

  .banner-info {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 600px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 30%, rgba(255,255,255, .6) 45%, rgba(255,255,255, .8) 65%, rgba(255, 255, 255, 1) 70%);
    .label {
      position: absolute;
      left: 58%;
      top: 170px;
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 100px;
      color: #101010;
    }
  }

  .contact-main {
    width: 1400px;
    margin: 0 auto;
    padding-top: 70px;
  }

  .sub-title {
    font-family: YouSheBiaoTiHei;
    font-size: 60px;
    color: #101010;
    margin-bottom: 70px;
  }

  .info-box {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 60px;
    .box {
      flex: 1;
      height: 360px;
      padding: 40px 56px;
      text-align: left;
      background: linear-gradient(180deg, rgba(227,233,255,0.71) 0%,rgba(209,219,219,0) 100%);
      border-radius: 30px 30px 0 0 ;
      
      color: #101010;
      box-sizing: border-box;
      .label {
        font-size: 32px;
        line-height: 64px;
      }
      .phone {
        display: flex;
        align-items: center;
        margin-top: 30px;
        font-size: 20px;
      }
      .number {
        color: #3019FF;
        font-weight: bold;
        font-size: 32px;
        margin-left: 20px;
      }
      img {
        width: 36px;
      }
      .info {
        font-size: 20px;
        line-height: 60px;
        margin: 20px 0 ;
      }
      .btn {
        width: 180px;
        height: 48px;
        background: linear-gradient(-89.88deg, rgba(48,25,255,1) 1.4%,rgba(114,144,255,1) 99.8%);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          transform: scale(1.02);
        }
        img {
          width: 20px;
          margin-right: 10px;
        }
      }
    }
  }

  .kefu-box {
    position: relative;
    width: 100%;
    .bg {
      width: 1200px;
      height: 360px;
      padding: 60px 100px;
      background: rgba(227,233,255,0.77);
      border-radius: 30px;
      text-align: left;
      
      color: #2313B0;
      .label {
        font-size: 32px;
        font-weight: bold;
      }
      .space {
        width: 60px;
        height: 5px;
        margin: 32px 0;
        background: #2313B0;
      }
      .label2 {
        font-size: 24px;
        color: #101010;
        line-height: 34px;
      }
      .phone {
        margin-top: 15px;
        font-size: 32px;
        font-weight: bold;
        display: flex;
        align-items: center;
        .small {
          color: #101010;
          font-size: 20px;
          font-weight: 400;
        }
      }
    }
    .kefu-bg {
      position: absolute;
      right: 0;
      bottom: -30px;
      height: 320px;
    }
  }

  .kefu-box2 {
    position: relative;
    width: 100%;
    height: 320px;
    margin-top: 130px;
    margin-bottom: 80px;
    display: flex;
    .kefu-bg2 {
      height: 320px;
    }
    .info {
      .sub-title2 {
        font-family: YouSheBiaoTiHei;
        color: #101010;
        font-size: 44px;
        line-height: 70px;
        text-align: left;
      }
      .item-box {
        margin-top: 136px;
        display: flex;
        justify-content: flex-start;
        gap: 60px;
        .item {
          text-align: left;
          
          font-size: 20px;
          color: #101010;
          line-height: 36px;
          .label {
            color: rgba(16,16,16, .7);
            margin-bottom: 6px;
          }
          .gray {
            color: rgba(16,16,16, .7);
          }
        }
      }
    }
  }


  .wechat-box {
    width: 1400px;
    height: 540px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    .circle-bg1 {
      position: absolute;
      left: 50px;
      top: 20px;
      width: 1300px;
      height: 1300px;
      background: rgba(114,144,255,.04);
      border-radius: 50%;
    }
    .circle-bg2 {
      position: absolute;
      left: 150px;
      top: 120px;
      width: 1100px;
      height: 1100px;
      background: rgba(114,144,255,.06);
      border-radius: 50%;
    }
    .circle-bg3 {
      position: absolute;
      left: 250px;
      top: 220px;
      width: 900px;
      height: 900px;
      background: rgba(114,144,255,.08);
      border-radius: 50%;
    }
    .circle-bg4 {
      position: absolute;
      left: 350px;
      top: 320px;
      width: 700px;
      height: 700px;
      background: rgba(114,144,255,.1);
      border-radius: 50%;
    }
    .phone-box {
      position: relative;
      z-index: 10;
      width: 380px;
      height: 540px;
      padding-top: 50px;
      background: url('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/phone-bg.png') center top / cover no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 260px;
        margin-top: 20px;
        margin-bottom: 24px;
      }
      .label {
        
        color: #101010;
        font-size: 32px;
        font-weight: bold;
      }
      .btn {
        width: 280px;
        height: 54px;
        background: linear-gradient(267.66deg, rgba(48,25,255,1) 34.5%,rgba(114,144,255,1) 98.21%);
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        
      }
    }
  }
}



// 小分比率适配
@media screen and (max-width: 1560px) {
  .contact-page {
    min-width: 1200px;
    .top-banner {
      height: 520px;
      .banner-info {
        height: 520px;
        .label {
          top: 140px;
          margin: 22px 0 30px;
          font-size: 64px;
          line-height: 84px;
        }
      }
    }

    .contact-main {
      width: 1200px;
      padding-top: 60px;
      .sub-title {
        font-size: 50px;
        margin-bottom: 60px;
      }
      .info-box {
        margin-bottom: 50px;
        .box {
          height: 320px;
          padding: 30px 40px;
          .label {
            font-size: 28px;
            line-height: 56px;
          }
          .phone {
            font-size: 18px;
          }
          .number {
            font-size: 28px;
          }
          .info {
            font-size: 18px;
            line-height: 50px;
            margin: 16px 0 ;
          }
          .btn {
            width: 160px;
            height: 40px;
            font-size: 16px;
          }
        }
      }

      .kefu-box {
        .bg {
          width: 1000px;
          height: 300px;
          padding: 50px 80px;
          .label {
            font-size: 26px;
          }
          .space {
            width: 50px;
            height: 4px;
            margin: 26px 0;
          }
          .label2 {
            font-size: 20px;
            line-height: 30px;
          }
          .phone {
            font-size: 26px;
            .small {
              font-size: 17px;
            }
          }
        }
        .kefu-bg {
          height: 280px;
          bottom: -26px;
        }
      }

      .kefu-box2 {
        height: 280px;
        margin-top: 100px;
        margin-bottom: 64px;
        .kefu-bg2 {
          height: 280px;
        }
        .info {
          .sub-title2 {
            font-size: 36px;
            line-height: 60px;
          }
          .item-box {
            margin-top: 100px;
            gap: 40px;
            .item {
              font-size: 18px;
              line-height: 32px;
            }
          }
        }
      }

      .wechat-box {
        width: 1200px;
        height: 500px;
        .circle-bg1 {
          width: 1100px;
          height: 1100px
        }
        .circle-bg2 {
          width: 900px;
          height: 900px
        }
        .circle-bg3 {
          width: 700px;
          height: 700px
        }
        .circle-bg4 {
          width: 500px;
          height: 500px;
        }
        .phone-box {
          width: 340px;
          height: 500px;
          padding-top: 40px;
          img {
            width: 240px;
            margin-top: 16px;
            margin-bottom: 20px;
          }
          .label {
            font-size: 28px;
          }
          .btn {
            width: 240px;
            height: 48px;
            font-size: 18px;
            border-radius: 24px;
          }
        }
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .contact-page {
    min-width: 1080px;
    .top-banner {
      height: 480px;
      .banner-info {
        height: 480px;
        .label {
          top: 120px;
          margin: 22px 0 30px;
          font-size: 56px;
          line-height: 66px;
        }
      }
    }

    .contact-main {
      width: 1080px;
      padding-top: 50px;
      .sub-title {
        font-size: 44px;
        margin-bottom: 50px;
      }
      .info-box {
        margin-bottom: 40px;
        .box {
          height: 280px;
          padding: 24px 32px;
          .label {
            font-size: 24px;
            line-height: 48px;
          }
          .phone {
            font-size: 16px;
          }
          .number {
            font-size: 24px;
          }
          .info {
            font-size: 16px;
            line-height: 40px;
            margin: 12px 0 ;
          }
          .btn {
            width: 140px;
            height: 36px;
            font-size: 14px;
          }
        }
      }

      .kefu-box {
        .bg {
          width: 880px;
          height: 280px;
          padding: 50px 70px;
          .label {
            font-size: 24px;
          }
          .space {
            width: 44px;
            height: 4px;
            margin: 22px 0;
          }
          .label2 {
            font-size: 20px;
            line-height: 30px;
          }
          .phone {
            font-size: 26px;
            .small {
              font-size: 17px;
            }
          }
        }
        .kefu-bg {
          height: 260px;
          bottom: -24px;
        }
      }

      .kefu-box2 {
        height: 280px;
        margin-top: 100px;
        margin-bottom: 64px;
        .kefu-bg2 {
          height: 280px;
        }
        .info {
          .sub-title2 {
            font-size: 36px;
            line-height: 60px;
          }
          .item-box {
            margin-top: 100px;
            gap: 40px;
            .item {
              font-size: 18px;
              line-height: 32px;
            }
          }
        }
      }

      .wechat-box {
        width: 1080px;
        height: 500px;
        .circle-bg1 {
          width: 980px;
          height: 980px
        }
        .circle-bg2 {
          width: 780px;
          height: 780px
        }
        .circle-bg3 {
          width: 580px;
          height: 580px
        }
        .circle-bg4 {
          width: 380px;
          height: 380px;
        }
        .phone-box {
          width: 300px;
          height: 440px;
          padding-top: 32px;
          img {
            width: 210px;
            margin-top: 16px;
            margin-bottom: 20px;
          }
          .label {
            font-size: 24px;
          }
          .btn {
            width: 210px;
            height: 42px;
            font-size: 16px;
            border-radius: 24px;
          }
        }
      }
    }
  }
}   


</style>